import axios from 'axios';
import { StatusResponse } from "../../types/statusResponseType";

export async function getServerStatus(): Promise<{data: StatusResponse}> {
  return await axios.get('/status/check');
}
